import { createStore } from 'vuex'

import { onEachPageTeardown } from '@app/adapters/page-teardown'

import dropdown from '../../shared/vue/store/modules/dropdown'

let store = null

export function clearStore() {
  store = null
}

onEachPageTeardown(clearStore)

export default function createInsightsStore() {
  if (store) {
    return store
  }

  store = createStore({
    modules: {
      dropdown,
    },
  })

  return store
}
